/* eslint-disable camelcase */
/**
 * ЗАВИСИМОСТИ
 */
import 'ion-rangeslider/css/ion.rangeSlider.min.css';
import $ from 'jquery';
import Borders from './modules/borders';
import InputMask from 'inputmask';
// eslint-disable-next-line no-unused-vars
import ionRangeSlider from 'ion-rangeslider';
import Observer from '../../common/scripts/observer';
import {Utils} from '../../common/scripts/utils';

const observer = new Observer();

/**
 * КОМПОНЕНТ
 */
class RangeSlider {
    constructor() {
        this.rangeSlider = {};
        this.borders = new Borders();
        this.changeFromAttr = 'data-from-change';
        this.changeToAttr = 'data-to-change';
        this.changeFromClass = 'range-slider__from-change';
        this.changeToClass = 'range-slider__to-change';
    }

    /**
     * Инициализация слайдера
     * @param {Object} options - внешние настройки
     */
    init(options) {
        // если нет настроек, то получаем из data-атрибута
        this.wrapper = options.wrapper;
        this.name = options.name;
        this.outerOptions = options.outerOptions || this.wrapper.querySelector('.j-range-slider__base').dataset;

        this.price = this.wrapper.querySelector('.j-range-price');

        this.oldFrom = this.outerOptions.from;
        this.oldTo = this.outerOptions.to;

        this._setOptions(options);
        this._initRangeSlider();
        this._getElements();
        this._initInputMask();
        this._bindEvents();
        this._subscribes();
        this._initBorders();
    }

    /**
     * Установка параметров
     * @param {Object} options - внешние настройки
     * @private
     */
    _setOptions(options) {
        this.options = {
            type            : this.outerOptions.type,
            min             : this.outerOptions.min,
            max             : this.outerOptions.max,
            from            : this.outerOptions.from,
            to              : this.outerOptions.to,
            step            : this._getNumber(this.outerOptions.step),
            min_interval    : this._getNumber(this.outerOptions.step),
            borderMin       : this.outerOptions.borderMin,
            borderMax       : this.outerOptions.borderMax,
            digit           : this.outerOptions.digit || false,
            validate        : this.outerOptions.validate,
            disable         : this.outerOptions.disabled || false,
            hide_from_to    : true,
            hide_min_max    : true,
            prettify_enabled: false,
            onStart         : (data) => {
                observer.publish('rangeSliderStart', data, this);
            },
            onChange: (data) => {
                this._updateInputs(data);
                this._changeBorders(data);
                this._updateChange();

                observer.publish('rangeSliderChange', data, this.name);

                if (options.onChange) {
                    options.onChange(data);
                }
            },
            onFinish: (data) => {
                observer.publish('rangeSliderFinish', data, this.name);

                if (options.onFinish) {
                    options.onFinish(data);
                }
            },
            onUpdate: (data) => {
                observer.publish('rangeSliderUpdate', data, this.name);

                if (options.onUpdate) {
                    options.onUpdate(data);
                }
            }
        };

        this.startOptions = this.options;
    }

    /**
     * Метод инициализирует плагин рэндж-слайдера
     */
    _initRangeSlider() {
        this.$rangeSlider = $(this.wrapper).find('.j-range-slider__base');
        this.$rangeSlider.ionRangeSlider(this.options);
    }

    /**
     * Метод получает требуемые элементы
     */
    _getElements() {
        this.inputs = Array.from(this.wrapper.querySelectorAll('.j-range-slider__input'));
        this.inputFrom = this.inputs[0];
        this.inputTo = this.options.type === 'double' ? this.inputs[1] : null;

        this.changeFrom = this.wrapper.hasAttribute(this.changeFromAttr);
        this.changeTo = this.wrapper.hasAttribute(this.changeToAttr);

        this.slider = this.$rangeSlider.data('ionRangeSlider');
        this.id = this.slider.input.id;
        this.rangeSlider[this.id] = this.slider;
    }

    _initInputMask() {
        if (!this.options.digit || !this.options.validate) {
            return;
        }

        this.inputs.forEach((item) => {
            new InputMask('decimal', {
                prefix        : item.dataset.prefix || '',
                suffix        : item.dataset.suffix || '',
                integerDigits : 10,
                placeholder   : ' ',
                rightAlign    : false,
                radixPoint    : '.',
                autoGroup     : true,
                groupSeparator: ' ',
                groupSize     : 3,
                autoUnmask    : true,
                onBeforeMask(value) {
                    if (!item.dataset.suffix) {
                        return;
                    }

                    const dynamicSuffix = item.dataset.suffix.split('|');

                    // Устанавливает динамический суффикс (например год/года/лет)
                    if (dynamicSuffix.length === 3) {
                        const suffixNew = Utils.pluralWord(Number(value), dynamicSuffix);

                        if (this.option('suffix').trim() === suffixNew) {
                            return;
                        }

                        // Не убирать, будет плохо
                        // (присваивается не то значение хз откуда, скорее всего ошибка плагина)
                        setTimeout(() => {
                            this.option({
                                suffix: ` ${suffixNew}`
                            });
                        }, 0);
                    }
                }
            }).mask(item);
        });
    }

    /**
     * Биндим события
     */
    _bindEvents() {
        this._onInputFromChange = this._onInputFromChange.bind(this);
        this._onInputToChange = this._onInputToChange.bind(this);

        this.inputFrom.addEventListener('change', this._onInputFromChange);

        if (this.options.type === 'double') {
            this.inputTo.addEventListener('change', this._onInputToChange);
        }
    }

    /**
     * Метод содержит в себе коллбэки на события других модулей.
     */
    _subscribes() {
        // Сброс слайдеров к дефолтному состоянию при сбросе фильтра в параметрическом.
        observer.subscribe('parametric:filterReset', () => {
            this._resetChange();
        });

        // Обновление слайдеров после получения данных от параметрического фильтра.
        observer.subscribe('parametric:filterSend', (data) => {
            this._updateBorders(data);
        });
    }

    /**
     * Обновление статуса потроганности
     * @private
     */
    _updateChange() {
        if (!this.changeFrom && (this.slider.result.from !== this._getNumber(this.oldFrom))) {
            this.changeFrom = true;
            this.wrapper.setAttribute(this.changeFromAttr, '');
            this.wrapper.classList.add(this.changeFromClass);
        }

        if (this.options.type === 'single') {
            return;
        }

        if (!this.changeTo && (this.slider.result.to !== this._getNumber(this.oldTo))) {
            this.changeTo = true;
            this.wrapper.setAttribute(this.changeToAttr, '');
            this.wrapper.classList.add(this.changeToClass);
        }
    }

    /**
     * Сброс потроганности
     * @private
     */
    _resetChange() {
        this.changeFrom = false;
        this.wrapper.removeAttribute(this.changeFromAttr);

        this.changeTo = false;
        this.wrapper.removeAttribute(this.changeToAttr);
    }

    /**
     * Изменение инпута "от"
     * @param {Object} event - объект события
     */
    _onInputFromChange(event) {
        // конвертируем в число, т.к после добавления разрядов получаем строку
        let val = this._getNumber(event.target.value);
        const startValue = 0;
        const oneDecimal = 1;
        const currentTo = this.slider.result.to;
        const type = this.options.type;

        // Если это инпут с разрядами то округляем до 1 знака после запятой, а если нет то до 0
        const decimal = this.options.validate === 'decimal' ? oneDecimal : startValue;

        // Если это одинарный инпут то шагом до сброса к мин и макс значению будет 0
        const step = type === 'single' ? startValue : this.options.step;

        if (val < this.slider.result.min) {
            val = this.slider.result.min;
        } else if (val > this.slider.result.max && type === 'single') {
            val = this.slider.result.max;
        } else if (val > currentTo) {
            val = currentTo - step;
        }

        val = val.toFixed(decimal);

        event.target.value = val;

        this._update({from: val});
        this._updateChange();
    }

    /**
     * Изменение инпута "до"
     * @param {Object} event - объект события
     */
    _onInputToChange(event) {
        // конвертируем в число, т.к после добавления разрядов получаем строку
        let val = this._getNumber(event.target.value);
        const startValue = 0;
        const oneDecimal = 1;
        const currentFrom = this.slider.result.from;

        // Если это инпут с разрядами то округляем до 1 знака после запятой, а если нет то до 0
        const decimal = this.options.validate === 'decimal' ? oneDecimal : startValue;

        if (val <= currentFrom) {
            val = currentFrom + this.options.step;
        } else if (val > this.options.max) {
            val = this.options.max;
        }

        val = val.toFixed(decimal);

        event.target.value = val;
        this._update({to: val});
        this._updateChange();
    }

    _update(data) {
        this.slider.update(data);

        // Нужно заново переинициализировать бордеры, т.к update все вычишает
        this._initBorders();
    }

    /**
     * Обновление инпутов
     * @param {Object} data - данные с новыми значениями
     */
    _updateInputs(data) {
        if (Utils.isSet(data.from)) {
            this.inputFrom.value = data.from;
        }

        if (data.to && this.options.type === 'double') {
            this.inputTo.value = data.to;
        }
    }

    /**
     * Обновление min и max
     * @param {Object} data - данные с новыми значениями
     */
    _updateRange(data) {
        if (Utils.isSet(data.from)) {
            this.oldFrom = data.from;
        }

        if (data.to && this.options.type === 'double') {
            this.oldTo = data.to;
        }
    }

    /**
     * Иницализация модуля для визуализации границ.
     */
    _initBorders() {
        // проксимуем настройки в экземпляр слайдера
        this.slider.result.borderMin = this.options.borderMin;
        this.slider.result.borderMax = this.options.borderMax;

        if (this.options.borderMin && this.options.borderMax) {
            this.borders.init(this.slider);
        }
    }

    /**
     * Изменение модуля визуализации границ при change слайдера.
     * @param {HTMLDivElement} data - Экземпляр слайдера на котором произошло событие.
     */
    _changeBorders(data) {
        if (this.options.borderMin && this.options.borderMax) {
            this.borders.change(data);
        }
    }

    /**
     * Обновление модуля визуализации границ при получении ответа от сервера.
     * @param {object} data - Данные с бэкэнда.
     */
    _updateBorders(data) {
        data.forEach((item) => {
            for (const key in item) {
                if (Utils.keyExist(this.rangeSlider, [key])) {
                    const borderMin = item[key].borderMin;
                    const borderMax = item[key].borderMax;

                    this._update(item[key]);

                    if (borderMin && borderMax) {
                        // Обновляем требуемые для модуля 'border' дата-атрибуты;
                        this.slider.result.borderMin = borderMin;
                        this.slider.result.borderMax = borderMax;
                        this.borders.update(this.slider);
                    }
                }
            }
        });
    }

    /**
     * Конвертация из строки с разрядами в число
     * @param {String} str - значение с разрядом
     * @returns {Number} - значение без разрядов
     */
    _getNumber(str) {
        const zero = 0;

        if (!str) {
            return zero;
        }

        return Utils.convertToNumber(str);
    }

    /**
     * Возвращает инпуты
     * @return {any[]} - массив инпутов
     */
    getInputs() {
        return this.inputs;
    }

    /**
     * Обновлят слайдер снаружи
     * @param {Object} data - внешние данные
     */
    update(data) {
        this._updateInputs(data);
        this._updateRange(data);
        this._update(data);
    }

    reset() {
        this.slider.reset();

        this.slider.remove();
        this.slider.init();
    }
}
/* eslint-enable camelcase */

export default RangeSlider;
